import { ModalHelper } from '../../components/modal/modal.helper';
var FooterComponent = (function () {
    function FooterComponent(_modal) {
        this._modal = _modal;
    }
    FooterComponent.prototype.ngOnInit = function () { };
    ;
    FooterComponent.prototype.openMessageModal = function () {
        this._modal.show("messageModal");
    };
    return FooterComponent;
}());
export { FooterComponent };
